import OrganizationChannelList from './holders/OrganizationChannelList'
import OrganizationContactInfo from './holders/OrganizationContactInfo'
import OrganizationCourseList from './holders/OrganizationCourseList'
import OrganizationEventList from './holders/OrganizationEventList'
import OrganizationInfo from './holders/OrganizationInfo'
import OrganizationNews from './holders/OrganizationNews'
import {OrganizationGroupsGrid} from "./holders/OrganizationGroups";

export const organizationRouteEntities = [
    {
        path: 'overview',
        component: OrganizationInfo,
        breadcrumbName: (t) => t('overview'),
    },
    {
        path: 'news',
        component: OrganizationNews,
        breadcrumbName: (t) => t('news'),
    },
    {
        path: 'groups',
        component: OrganizationGroupsGrid,
        breadcrumbName: (t) => t('groups / ministries'),
    },
    {
        path: 'channels',
        component: OrganizationChannelList,
        breadcrumbName: (t) => t('channels'),
    },
    {
        path: 'events',
        component: OrganizationEventList,
        breadcrumbName: (t) => t('events'),
    },
    {
        path: 'courses',
        component: OrganizationCourseList,
        breadcrumbName: (t) => t('courses'),
    },
    {
        path: 'contacts',
        component: OrganizationContactInfo,
        breadcrumbName: (t) => t('contact'),
        // isInvisible: (organization) => _.isEmpty(organization?.contacts),
    },
]
